"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _college = require("@/api/backmen/college");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialog: false,
      fromData: {
        id: "",
        majorName: "",
        majorCode: '',
        provinceId: this.$store.getters.provinceId
      },
      rules: {
        majorName: [{
          required: true,
          message: '此项不能为空',
          trigger: 'blur'
        }],
        majorCode: [{
          required: true,
          message: '此项不能为空',
          trigger: 'blur'
        }]
      },
      tit: '新增',
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "专业名称",
        prop: "majorName",
        isShow: true,
        width: "100"
      }, {
        name: "专业code",
        prop: "majorCode",
        isShow: true,
        width: "200",
        timeFormat: "dateYMD"
      }],
      minWidth: 200,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {},
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      checkBoxs: []
    };
  },
  methods: {
    submit: function submit(v) {
      var _this = this;
      // console.log("v",v)
      this.$refs[v].validate(function (valid) {
        if (valid) {
          if (_this.tit == '新增') {
            (0, _college.saveMajor)(_this.fromData).then(function (res) {
              if (res.msg == '操作成功') {
                _this.$message.success(res.msg);
                _this.close();
                _this.getList();
              }
            });
          } else if (_this.tit == '编辑') {
            (0, _college.editMajor)(_this.fromData).then(function (res) {
              if (res.msg == '操作成功') {
                _this.$message.success(res.msg);
                _this.close();
                _this.getList();
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close: function close() {
      this.dialog = false;
      this.fromData.name = '';
      this.fromData.linkUrl = '';
      this.fromData.id = '';
    },
    // 新增
    add: function add() {
      this.dialog = true;
      this.tit = '新增';
    },
    // 编辑
    edit: function edit(e) {
      // console.log('e',e)
      this.dialog = true;
      this.tit = '编辑';
      this.fromData.name = e.name;
      this.fromData.linkUrl = e.linkUrl;
      this.fromData.id = e.id;
    },
    // 获取列表
    getList: function getList() {
      var _this2 = this;
      (0, _college.majorList)({
        pageNum: 1,
        pageSize: 99999,
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.listData = res.data.list;
        }
      });
    },
    // 模糊搜索新闻分类
    search: function search(val) {
      this.queryValue = val.queryValue;
      this.getList();
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this3 = this;
      // console.log('row',row)
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _college.removeMajor)({
          idList: id
        }).then(function () {
          _this3.getList();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消删除。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this4 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getList();
    }
  },
  created: function created() {
    this.getList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};